import { render, staticRenderFns } from "./plan-comercializador.vue?vue&type=template&id=ae4630ea&scoped=true&"
import script from "./plan-comercializador.vue?vue&type=script&lang=js&"
export * from "./plan-comercializador.vue?vue&type=script&lang=js&"
import style0 from "./plan-comercializador.vue?vue&type=style&index=0&id=ae4630ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4630ea",
  null
  
)

export default component.exports